module.exports = __webpack_public_path__ + "9ead77b35a4f604c46102f1f1d5ad0a2.svg";